import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import './registerServiceWorker'
import i18n from './i18n'
import BootstrapVue from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import globalMixin from '@/mixins/global-mixin.js'
import VeeValidate from 'vee-validate'
import validatorMessages from './locales/validator'
import 'swiper/dist/css/swiper.css'
import VueMeta from 'vue-meta'
import VueTheMask from 'vue-the-mask'
(window as any)['$'] = (window as any)['jQuery'] = require('jquery');
(window as any)['persianDate'] = require('persian-date/dist/persian-date.js')
require('persian-datepicker/dist/js/persian-datepicker.js')
require('persian-datepicker/dist/css/persian-datepicker.css')
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)

Vue.use(VeeValidate, {
  dictionary: {
    en: { messages: validatorMessages }
  }
})
Vue.use(VueTheMask)
Vue.mixin(globalMixin)
Vue.config.productionTip = true
new Vue(
  {

    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
